import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'cat-01': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20stylish%20white%20and%20pastel%20sneakers%20arranged%20on%20light%20cream%20surface%20with%20soft%20natural%20daylight%20from%20window%20editorial%20fashion%20photography%20style%20airy%20composition%20european%20aesthetic%20high%20detail%20gentle%20shadows%20warm%20neutral%20background&width=600&height=400&seq=cat-shoes&orientation=landscape',
  'cat-02': 'https://readdy.ai/api/search-image?query=Soft%20aesthetic%20photography%20of%20neutral%20tone%20oversized%20hoodies%20and%20sweaters%20folded%20neatly%20on%20light%20beige%20linen%20fabric%20surface%20with%20warm%20gentle%20sunlight%20minimalist%20editorial%20style%20clean%20composition%20european%20fashion%20vibe%20airy%20atmosphere%20high%20detail&width=600&height=400&seq=cat-hoodies&orientation=landscape',
  'cat-03': 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20photography%20of%20pastel%20colored%20cotton%20t-shirts%20neatly%20arranged%20on%20light%20cream%20background%20with%20soft%20natural%20lighting%20clean%20editorial%20style%20airy%20composition%20european%20aesthetic%20high%20detail%20gentle%20shadows&width=600&height=400&seq=cat-tshirts&orientation=landscape',
  'cat-04': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20lightweight%20jackets%20and%20outerwear%20in%20neutral%20earth%20tones%20displayed%20on%20light%20wooden%20surface%20with%20soft%20daylight%20editorial%20fashion%20style%20clean%20composition%20european%20aesthetic%20high%20detail%20warm%20atmosphere&width=600&height=400&seq=cat-jackets&orientation=landscape',
  'cat-05': 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20trousers%20and%20shorts%20in%20soft%20neutral%20colors%20laid%20flat%20on%20light%20cream%20surface%20with%20gentle%20natural%20lighting%20minimalist%20editorial%20style%20airy%20composition%20european%20fashion%20aesthetic%20high%20detail&width=600&height=400&seq=cat-pants&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-light leading-tight">
            Jump to Store
            <br />
            <span className="font-semibold">Explore Categories</span>
          </h2>
          <p className="text-sm text-foreground-500 max-w-xs lg:text-right">
            14 product types synced from kaspreadsheet.com &mdash; click any category to start comparing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-foreground-900 rounded-lg overflow-hidden cursor-pointer md:row-span-2"
          >
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-xl md:text-2xl text-white font-semibold">GTBuy Sheet</h3>
              <p className="mt-1 text-white/60 text-xs md:text-sm">Your complete comparison engine</p>
            </div>
            <div className="px-5 md:px-6 pb-5 md:pb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20product%20flat%20lay%20photography%20with%20sneakers%20hoodie%20cap%20and%20accessories%20arranged%20on%20light%20cream%20surface%20soft%20warm%20lighting%20editorial%20style%20clean%20european%20aesthetic%20composition%20high%20detail%20airy%20atmosphere&width=600&height=500&seq=cat-gtbuy-main&orientation=landscape"
                alt="GTBuy sheet main store"
                className="w-full h-48 md:h-64 object-cover rounded-md object-top"
              />
            </div>
            <div className="absolute bottom-5 left-5 md:bottom-6 md:left-6">
              <span className="inline-flex items-center gap-2 bg-white text-foreground-900 px-5 py-2.5 rounded-full text-sm font-medium group-hover:bg-background-100 transition-colors whitespace-nowrap">
                buy it now
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </div>
          </a>

          {categories.slice(0, 4).map((cat, idx) => (
            <a
              key={cat.seq}
              href={cat.href}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer flex flex-col"
            >
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <span className="inline-flex items-center gap-1.5 self-start border border-foreground-200 text-foreground-500 text-xs px-2.5 py-1 rounded-full mb-3">
                  <i className="ri-price-tag-3-line text-xs"></i>
                  <span>Category</span>
                </span>
                <div className="flex-1">
                  <img
                    src={categoryImages[cat.seq] || categoryImages['cat-01']}
                    alt={cat.name}
                    className="w-full h-36 md:h-40 object-cover rounded-md object-top"
                  />
                </div>
                <h3 className="mt-3 font-heading text-lg md:text-xl text-foreground-900 font-semibold">{cat.name}</h3>
                <p className="mt-1 text-xs text-foreground-400">Compare prices instantly</p>
                <span className="mt-3 inline-flex items-center gap-2 bg-foreground-900 text-white px-4 py-2 rounded-full text-xs font-medium group-hover:bg-foreground-800 transition-colors self-start whitespace-nowrap">
                  View in Sheet
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}